import { NSARouterMakerResult } from 'namirasoft-account-react';
import { NamingConvention } from 'namirasoft-core';
import { LogGroupRow } from "namirasoft-log";
import { NamirasoftMap } from 'namirasoft-site-map';
import { NSBox, NSBoxEntity, NSBoxEnum, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from 'namirasoft-site-react';
import { StorageRow, StorageStatus, StorageType } from 'namirasoft-storage';
import { Component, createRef } from 'react';
import AssignmentsTable from '../components/AssignmentsTable';
import StorageConnect from '../components/StorageConnect';
import StorageConnectionEditor from '../components/StorageConnectionEditor';
import { StorageEntities } from '../StorageEntities';
import { StorageLayout } from '../StorageLayout';
import { StorageRouterProps } from '../StorageRouterProps';

export interface StorageEditPageProps extends NSARouterMakerResult, StorageRouterProps
{
    isEdit: boolean;
}

export interface StorageEditPageState
{
    type: StorageType | null;
}

export default class StorageEditPage extends Component<StorageEditPageProps, StorageEditPageState>
{
    private NSBoxString_Name = createRef<NSBoxString>();
    private NSBoxEnum_Type = createRef<NSBoxEnum<StorageType>>();
    private NSBoxEntity_LogGroupID = createRef<NSBoxEntity<LogGroupRow>>();
    private NSBoxTextArea_Description = createRef<NSBoxTextArea>();
    private StorageConnectionEditor_Ref = createRef<StorageConnectionEditor>();

    constructor(props: StorageEditPageProps)
    {
        super(props);
        this.state = { type: null };
    }

    formatName(name: string)
    {
        return NamingConvention.auto.convert(name, NamingConvention.Pascal_Case_Space);
    }

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <StorageLayout<StorageRow, StorageRow>
                {...this.props}
                pages={{
                    entity: StorageEntities.storage(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                ui: {
                                    extra_tabs: [
                                        {
                                            title: "Connection",
                                            clicked: true,
                                            getContent: () => (
                                                <StorageConnectionEditor
                                                    ref={this.StorageConnectionEditor_Ref}
                                                    type={this.state.type}
                                                    {...this.props}
                                                />
                                            ),
                                        }
                                    ]
                                },
                                editor: {
                                    getInputRow: (): StorageRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let type = this.NSBoxEnum_Type.current?.getValueEnumOne(StorageType, StorageType.AWSS3) ?? StorageType.AWSS3;
                                        let log_group_id = this.NSBoxEntity_LogGroupID.current?.getValueOne() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        let meta = this.StorageConnectionEditor_Ref.current?.getMeta(type) ?? {};
                                        return {
                                            id: "",
                                            user_id: "",
                                            workspace_id: "",

                                            name,
                                            type,
                                            log_group_id,
                                            ui_url: "",
                                            meta,
                                            description,

                                            status: StorageStatus.InProgress,
                                            status_message: "",
                                            created_at: new Date(),
                                            updated_at: new Date()
                                        };
                                    },
                                    setRow: (row: StorageRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEnum_Type.current?.setValueOne(row.type);
                                        this.NSBoxEntity_LogGroupID.current?.setValueOne(row.log_group_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);

                                        this.setState((prev) => ({ ...prev, type: row.type }), () =>
                                        {
                                            this.StorageConnectionEditor_Ref.current?.setMeta(row.type, row.meta);
                                        });
                                    }
                                }
                            },
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                            {
                                                title: "Connection",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <StorageConnect
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        }
                    }
                }}
            >
                <NSColumn style={{ maxWidth: "35rem" }}>
                    <NSRow>
                        <NSBoxString
                            ref={this.NSBoxString_Name}
                            title="Name"
                            required
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxEnum<StorageType>
                            ref={this.NSBoxEnum_Type}
                            title="Type"
                            required
                            multiple={false}
                            getEnumObject={() => StorageType}
                            getTitle={(item) => this.formatName(item)}
                            onChanged={() =>
                            {
                                let type = this.NSBoxEnum_Type.current?.getValueEnumOne(StorageType, StorageType.AWSS3) ?? null;
                                this.setState({ type });
                            }}
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxEntity<LogGroupRow>
                            ref={this.NSBoxEntity_LogGroupID}
                            title="Log Group"
                            required={false}
                            multiple={false}
                            table={namirasoft.log.tables.log_group}
                            getTitle={(item) => item.name}
                            getValue={(item) => item.id}
                            getSort={() => null}
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                    <NSRow>
                        <NSBoxTextArea
                            ref={this.NSBoxTextArea_Description}
                            title='Description'
                            required={false}
                            style={{ width: NSBox.width.double }}
                        />
                    </NSRow>
                </NSColumn>
            </StorageLayout>
        );
    }
}